<dw-grid-list-page
  [activeView]="agGrid.activeView"
  [showCreationBtn]="false"
  [showDeleteBtn]="false"
  [showDuplicateBtn]="false"
  [showExportBtn]="false"
  [enableDeleteBtn]="false"
  class="h-100"
>
  <dw-grid-ag-grid
    [columnDefs]="colDefs"
    [datasource]="datasource"
    [alwaysProjectedColumns]="['docRole']"
    (rowClicked)="rowClicked($event)"
    (selectedRowsClicked)="selectedRowsClicked($event)"
    #agGrid
    context="AllDocsWithFolders"
    class="h-100"
  >
  </dw-grid-ag-grid>
</dw-grid-list-page>
